{
  "accept": "Roziman",
  "activate account": "Hisobni faollashtirish",
  "added doctor to favorite doctror": "{name} siz qiziqish bildirgan vrach sifatida roʻyxatdan oʻtkazildi.",
  "addFiles": "Ilova qilingan fayl",
  "after payment is confirmed, completed.": "To'lov tasdiqlangandan so'ng ariza yakunlanadi.",
  "agree": "Rozilik",
  "agree to all terms and conditions": "Barcha shartlarga roziman.",
  "agree to all terms and conditions.": "Barcha shartlarga roziman.",
  "agreeAll": "Hammasig rozi bo'lish",
  "Agreement": "Foydalanish shartlari",
  "Agreement Content": "Foydalanish shartlari",
  "allowingRecive": "Qabul qilishga rozilik bildirish",
  "attach files": "Faylni ilova qilish",
  "attached files": "Faylni ilova qilish",
  "Attachments": "Ilovalar",
  "available email": "Elektron pochtadan foydalanish mumkin",
  "back": "Ortga qaytish",
  "birthDate": "Tug'ilgan sana",
  "CalcelHeader": "Bekor qilmoqchimisiz?",
  "cancel": "Bekor qilish",
  "Cancel": "Bekor qilish",
  "cancel payment and reservation": "To'lovni bekor qilish va bekor qilish",
  "cancel reservation": "Qabul bronini bekor qilish",
  "canceled": "Bekor qilish",
  "Canceled": "Bekor qilish",
  "change": "Oʻzgartirish",
  "change docor": "Shifokorni almashtirish",
  "change password": "Parolni o'zgartirish",
  "changed password": "Parol o'zgartirildi.",
  "changePassword": "Parolni oʻzgartirish",
  "check email": "{email} elektron pochtangizni tekshiring.",
  "check email verificaion": "Iltimos, elektron pochta oldin ro'yxatdan o'tmaganligini tekshiring.",
  "check payment": "To'lovni tasdiqlash",
  "check prescription": "Retseptni tekshiring",
  "check spam mail box": "Spam pochta qutingizni tekshiring",
  "Check your email or password": "Kirish ma'lumotlaringizni tekshiring.",
  "CheckingItNow": "Tekshirilmoqda.",
  "chief complaint": "Asosiy simptomlar",
  "chief complaint & files": "Simptomlar va fayllarni ilova qilish",
  "close": "Yopish",
  "complete": "Bajarildi",
  "complete to sign-up": "Tugmani tanlaganingizdan so'ng ro'yxatdan o'tishn yakunlanadi.",
  "Completed": "Javob yuborildi",
  "confirm": "Tasdiqlash",
  "confirm cancel reservation": "Qabul broni bekor qilingandan keyin o'zgartirishlar kiritib bo'lmaydi. ^ mazkur qabul bronini bekor qilmoqchimisiz?",
  "confirm delete file": "Mazkur faylni oʻchirib tashlamoqchimisiz?",
  "confirm new password": "Yangi parolni tasdiqlang",
  "confirm reservation": "Qabul bronini tasdiqlash",
  "confirm withdrawal": "Haqiqatan ham chiqib ketmoqchimisiz?",
  "confirm2": "Mazmunini tekshirish",
  "confirmed within one hour on average": "O'rtacha 1 soat ichida tasdiqlanadi",
  "confirmemail": "Elektron pochtani tekshirish",
  "connected count to room": "{count} nafar ishtirokchi qatnashmoqda",
  "Copied to clipboard": "Bufer xotiraga nusxalandi.",
  "copy share link": "Taklif havolasidan nusxa olish",
  "DataType": "Fayl turi",
  "date (from)": "Boshlanish kuni",
  "date (to)": "Boshlanish kuni",
  "dayNames": "yakshanba, dushanba, seshanba, chorshanba, payshanba, juma, shanba",
  "dayNamesMin": "yak, du, se, chor, pay, ju, shan",
  "dayNamesShort": "yak, du, se, chor, pay, ju, shan",
  "DCS": "Onlayn konsultatsiya xizmati",
  "default": "Standart",
  "desired date": "Davolanish sanasi",
  "desired date/time": "Sana va vaqt",
  "desired date/time can be selected after doctor selected": "Sana va vaqtni vrachni tanlagandan keyin tanlash va o'zgartirish mumkin.",
  "desired time": "Davolanish vaqti",
  "did you not receive verification code via email": "Elektron pochta orqali tasdiqlash kodini ololmadingizmi?",
  "didnt receive verification email": "Tasdiqlash xati  kelmadimi?",
  "direct input": "To'g'ridan-to'g'ri kiritish",
  "Dispense": "Dori tayyorlandi",
  "do change": "O'zgartirish",
  "do not show one week": "7 kun davomida ko'rsatilmasin",
  "do save": "Saqlash",
  "doctor": "Vrach",
  "doctor name": "Vrachning F.I.SH",
  "doctor or dept": "Vrach yoki bo'linma",
  "doctor response": "Vrachning javobi",
  "download": "Yuklab olish",
  "Drag and drop files to here to upload.": "Ilova qilinadigan faylni sichqoncha bilan tortib olib keling yoki [Faylni tanlash] tugmasini bosing.",
  "drop files to here": "Faylni tashlang",
  "edit": "Tahrirlash",
  "edit personal information": "Shaxsiy ma'lumotlarni tahrirlash",
  "edit requested data": "Hamkorlikdagi maslahat uchun qabulni tahrirlash",
  "email": "Elektron pochta",
  "email already in use": "Mazkur elektron pochta allaqachon ishlatilmoqda",
  "email confirmed": "Elektron pochta tasdiqlandi.",
  "EmailCheck": "Takror kiritilganini tekshirish",
  "EmailSendOK": "Kiritilgan elektron pochtaga xat yuborildi.",
  "emptyMessage": "",
  "enter at least two characters without spaces": "Bo'sh joy qoldirmasdan kamida ikkita belgi kiriting.",
  "error": "Xatolik",
  "Error": "Xatolik",
  "error occured. please retry later": "Xatolik ro'y berdi. Iltimos keyinroq yana urinib ko'ring.",
  "expire date": "Tugash muddati",
  "Failed to copy to clipboard": "Bufer xotiraga nusxalash imkonsiz.",
  "failed to save": "Saqlab bo'lmadi",
  "failed to sign up": "Ro‘yxatdan o‘tish amalga oshmadi",
  "familyName": "Jinsi",
  "favorite doctors": "Qiziqish bildirilgan vrach",
  "female": "Ayol",
  "fetch failed": "Xizmatga ulanishning imkoni yo'q.",
  "file-list": {
    "desc": {
      "a": "DICOM tasvirlar.ZIP fayl shaklidan zichlagandan so'ng yuklash",
      "b": "IPhone orqali suratga olingan video tasvirni ko'rib bo'lmasa",
      "c": "bu yerga",
      "d": "bosing",
      "e": "[Mediani suratga olish]",
      "f": "bilan tanishib chiqing"
    }
  },
  "FileAttachments": "Simptomlar fotosurati ilova qilish",
  "FileCancel": "Ilova qilishni bekor qilish",
  "FileChoose": "Faylni tanlash",
  "FileManager": "Fayl menejer",
  "FileTitle": "Fayl nomi",
  "FileType": "Fayl kengaytmasi",
  "Fileupload": "Faylni ilova qilish",
  "fill-form-data": "Roʻyxatdan oʻtish uchun zarur bo'lgan maʼlumotlarni kiriting.",
  "filtered by dept": "Tibbiyot bo'linma bo'yicha qidiruv",
  "finding keywords (requested)": "Vrach, shifoxona, tibbiyot bo'linmasi va boshqalar.",
  "finished sign up": "Yakunlandi.",
  "first name": "F.I.SH",
  "firstName": "F.I.SH",
  "fold": "Yopish",
  "forgotPassword": "Parol esdan chiqdi",
  "ForOpinion": "Xulosa uchun ariza berish",
  "from date": "Boshlanish kuni",
  "full name": "Familiya",
  "home": "Bosh sahifa",
  "home-intro-1": "Oldingidan boshqacha davolash,",
  "home-intro-2": "Bir oz o'zgacha video orqali qo'shma konsultatsiya",
  "how to take appointment for non-face-to-face cooperation": "Vrachni tanlab, simptomlaringizni yuborganingizdan so'ng, qo'shma konsultatsiya uchun qabulga yozilish so'rovingiz yakunlanadi.",
  "impossible to confirm": "Tasdiqlab bo‘lmadi",
  "InfoModify": "A'zolik ma'lumotlarini tahrirlash",
  "input chief complaint": "Asosiy simptomlarni kiritish",
  "input new password": "Yangi parolni kiriting.",
  "input new password confirm": "Yangi parolni qayta kiriting.",
  "input old password": "Oldingi parolni kiriting.",
  "input your email address": "Ro'yxatdan o'tish paytida kiritgan elektron pochta manzilingizni kiriting",
  "input-email": "Elektron pochta manzilingizni kiriting.",
  "input-password": "Parolni kiriting.",
  "insertDateTime": "Ariza sanasi",
  "invited-info": "Ishtirokchi nomi va taklif parolini kiritib, ishtirok etishni bosing. Taklif qiluvchi xon yaratganidan so'ng ishtirok etishingiz mumkin.",
  "invited-title": "Videochatga taklif",
  "inviter": "Taklif qiluvchi",
  "join": "Ro'yxatdan o'tish",
  "join chat": "Chatga qo'shilish",
  "korea standard time": "Koreya standart vaqti",
  "last name": "Jinsi",
  "LastOrder": "Oxirgi to'lov",
  "legal": "Shaxsiy ma'lumotlar bilan ishlash siyosati / Foydalanish shartlari",
  "List of Doctors": "Vrachni tanlash",
  "login failed": "Kirishda xatolik",
  "make sure the correct email address": "To'g'ri elektron pochta manzilini ro'yxatdan o'tkazganingizga ishonch hosil qiling.",
  "male": "Erkak",
  "medically-vulnerable": "Tibbiy jihatdan yordamga muhtoj hudud",
  "mofidy requested second opinion": "Xulosa so'roviga o'zgartirish kiritish",
  "monthNames": "yanvar, fevral, mart, aprel, may, iyun, iyul, avgust, sentyabr, oktyabr, noyabr, dekabr",
  "monthNamesShort": "yanvar, fevral, mart, aprel, may, iyun, iyul, avgust, sentyabr, oktyabr, noyabr, dekabr",
  "more": "ko'rish",
  "my doctors": "Qiziqish bildirilgan vrach",
  "my page": "Mening sahifam",
  "MyPage": "Mening sahifam",
  "name": "Familiya",
  "new password": "Yangi parolni tasdiqlash",
  "newPassword": "Yangi parol",
  "newPasswordConfirm": "Yangi parolni tasdiqlash",
  "newRequest": "Ariza yuborish",
  "newRequestOnlineCare": "Qabul uchun ariza yuborish",
  "newRequestSecondOpinion": "Ikkilamchi xulosa uchun ariza yuborish",
  "next": "Keyingi",
  "Next": "Keyingi",
  "No": "Yo'q",
  "non-face-to-face cooperation": "Masofaviy qo'shma konsultatsiya",
  "not confirmed email": "Elektron pochta tasdiqlanmadi",
  "ok": "Tasdiqlash",
  "online-care-intro-1": "Yuqori qon bosimi va diabet kabi surunkali kasalliklarga chalingan bemorlarni, gripp va shamollashga o'xshash umumiy kasalliklarni davolash",
  "online-care-intro-2": "Qabulga yozilgan sanada video orqali masofaviy qo'shma konsultatsiya",
  "OnlineCare": "Onlayn yuzma-yuz konsultatsiya (retsept)",
  "Page not found": "Sahifa topilmadi.",
  "paid history": "To'lov tarixi",
  "paid list": "To'lov tafsilotlari",
  "paid then completed": "Sizning arizangiz to'lov qilingandan keyin yuboriladi.",
  "participant": "Ishtirokchi",
  "password": "Maxfiy soʻz",
  "password changed": "Parol o'zgartirildi.",
  "Password not correct": "Parollar mos kelmaydi.",
  "password was changed or expired": "Parol allaqachon o'zgartirilgan yoki o'zgartirish muddati tugagan.",
  "password-rules": "6 yoki undan ortiq harf, raqam",
  "passwordConfirm": "Yangi parolni tasdiqlash",
  "pay": "To'lov",
  "payment": "To'lov",
  "PayReady": "To'lov kutilmoqda",
  "pharmacy": "Dorixona",
  "PharmacyNone": "Tanlamaslik",
  "Phone number": "Telefon raqami",
  "phoneNumber": "Telefon raqami",
  "pi-agreement": "Shaxsiy ma'lumotlarni taqdim etishga rozilik bildirish",
  "prescription": "Retsept",
  "Prev": "Oldingi",
  "previous": "Oldingi",
  "privacy": "Shaxsiy ma'lumotlarni qayta ishlash siyosati",
  "Privacy Policy": "Shaxsiy ma'lumotlarni qayta ishlash siyosati",
  "Privacy Policy Content": "Shaxsiy ma'lumotlarni qayta ishlash siyosati",
  "proceeding": "Jarayonda",
  "profile": "Shaxsiy ma'lumotlar",
  "quick": "Tez",
  "quick reservation description": "O'zingiz istagan vrach va qabul sana/vaqtini tanlash orqali davolanish uchun ariza qoldiring.",
  "ReceptionCompleted": "Ariza yuborildi",
  "ReceptionSaveHeader": "Ariza yuborasizmi?",
  "recommendted browsers": "Tavsiya etilgan brauzer",
  "refresh": "Yangilash",
  "refund and reject": "To'lovni qaytarish tugatildi va to'lov qaytarildi",
  "refunded": "To'lovni qaytarish",
  "Refused": "Qaytarildi",
  "registrationcompleted": "Roʻyxatdan oʻtish tugallandi",
  "reject": "Qaytarish",
  "rejected": "Qaytarildi",
  "remember me": "Login holatida saqlash",
  "remove": "Oʻchirish",
  "Remove": "Oʻchirish",
  "request": "So'rov",
  "request appointment": "Yuborish",
  "request comments": "Qabul broni bo'yicha izohlar",
  "request kind": "Tur",
  "request quick reservation": "Tez tibbiy yordam uchun murojaat",
  "request reservation": "Ariza qabul qilish",
  "request second opinion": "Ikkilamchi xulosa uchun so'rov",
  "requested": "Ariza yuborish",
  "Requested": "Qabul uchun ariza yuborish",
  "requested and wait payid": "Ariza va to'lov kutilmoqda",
  "requested count": "Ariza tafsilotlari",
  "requested detail information": "Ariza tafsilotlari",
  "requested list": "Ariza tafsilotlarini ko'rish",
  "RequestedQuick": "Tez davolanish",
  "required": "Shart",
  "Required information is required": "To'ldirish shart bo'lgan ma'lumotlarni kiriting.",
  "required phone number for servie": "Xizmatdan foydalanish uchun mobil telefon raqamingizni kiriting.",
  "resend verification email": "Tasdiqlash xatini qayta yuborish",
  "reserved date/time": "Qabul broni sanasi va vaqti",
  "reset": "Tanlovni bekor qilish",
  "reset password": "Parolni tiklash",
  "resetpassword": "Parolni o'zgartirish",
  "resetPasswordCompleted": "Parol o'zgartirildi",
  "respond count": "Javob berildi",
  "respond list": "Tugallanish tarixi",
  "respondDateTime": "Javob sanasi",
  "responded": "Bajarildi",
  "response": "Javob",
  "Result": "Natija",
  "Return": "Orqaga qaytish",
  "room name": "Xona nomi",
  "room status": "Xona holati",
  "save": "Saqlash",
  "save response": "Javobni saqlash",
  "Saved": "Saqlandi.",
  "saved requesting reservation": "Ariza qabul qilindi.",
  "SavedFavorites": "Oilaviy shifokor sifatida tanlandi.",
  "SaveHeader": "Saqlaysizmi?",
  "Scheduled": "Qabulga yozilish tasdiqlandi",
  "scheduled date/time": "Qabul sanasi va vaqti",
  "scheduledDatetime": "Qabul sanasi va vaqti",
  "search": "Izlash",
  "search failed": "Qidiruv xatosi",
  "second opinion": "Ikkilmamchi xulosa",
  "second-opinion-intro-1": "Boshqa kasalxonalardan saraton kasalligini davolash, jarrohlik kabi tibbiy ko'rik fayllari asosida",
  "second-opinion-intro-2": "Mutaxassis xulosasi zarur bo'lsa (3-7 kun talab qilinadi)",
  "SecondOpinion": "Second Opinion (Ikkilamchi xulosa)",
  "SecondOpinion2": "Ikkilamchi xulosa",
  "Select a Dept": "Bo'linmani tanlang",
  "select a hospital": "Shifoxonani tanlash",
  "Select a hospital": "Shifoxonani tanlash",
  "select a hospital to requesting": "Davolanadigan shifoxonani tanlang.",
  "select desired date/time": "Sana va vaqtni tanlash",
  "select doctor": "Vrachni tanlash",
  "select hopital and doctor": "Kasalxona va shifokor tanlash",
  "sent confirming email": "Tasdiqlash xati yuborildi.",
  "sent verification email": "Tasdiqlash xati yuborildi.",
  "serious illness": "Og'ir kasallik",
  "sex": "Jinsi",
  "sexF": "Ayol",
  "sexM": "Erkak",
  "show detail": "Batafsil o'qish",
  "show detail profile": "Profil tafsilotlarini ko'rish",
  "sign in": "Tizimga kirish",
  "Sign in": "Tizimga kirish",
  "sign out": "Tizimdan chiqish",
  "sign up": "A'zo bo'lib ro'yxatdan o‘tish",
  "sign-in-titl-1": "Siz konsultatsiya vaqtini tanlashingiz va masofaviy qo'shma konsultatsiya olishingiz mumkin.",
  "sign-in-titl-2": "Bu jiddiy kasalliklar uchun ikkilamchi xulosani taqdim etish xizmati hisoblanadi.",
  "sign-up": "A'zo bo'lish",
  "signin": "Tizimga kirish",
  "Signout": "Tizimdan chiqish",
  "signup": "A'zo bo'lish",
  "signup-title": "Hali ro'yxatdan o'tmaganmisiz?",
  "signup-title-1": "Ro'yxatdan o'tgan a'zolarni boshqarish uchun biz shaxsiy ma'lumotlarni quyidagi tarzda to'plash, foydalanish va taqdim etishni amalga oshiramiz.",
  "signup-title-2": "Tekst mazmunini diqqat bilan o'qing va rozi bo'lish yoki qilmaslik haqida qaror qabul qiling.",
  "sms": "SMS",
  "Status": "Hozirgi holat",
  "submit": "Topshirish",
  "submit application": "Yuborish",
  "take appointment": "Qo'shma konsultatsiya uchun qabulga yozilish",
  "take appointment for non-face-to-face cooperation": "Qo'shma konsultatsiya uchun qabulga yozilish",
  "take average one week": "3-7 kun talab qilinadi",
  "terms of use": "Foydalanish shartlari",
  "there is no selectable doctors": "Tanlash uchun vrach yo'q.",
  "time standard": "standart",
  "title": "Sarlavha",
  "to date": "Tugash kuni",
  "toggle favarite doctor": "Yana bir marta bosish orqali qiziqish bildirilgan vrachni bekor qilishingiz mumkin.",
  "totalCallTime": "Qo'ng'iroq vaqti",
  "Unable to load user": "Foydalanuvchi topilmadi.",
  "unfold": "Ochish",
  "update is completed": "Tahrirlandi",
  "User account locked out": "Tizimga kirish urinishlari limitdan oshib ketdi, keyinroq qayta urinib koʻring.",
  "User changed their password Failed": "Invalid Password",
  "User not found": "Foydalanuvchi topilmadi.",
  "userInfo": "Foydalanuvchi ma'lumotlari",
  "userName": "Foydalanuvchining F.I.SH",
  "validateError": "To'ldirish shart bo'lgan qatorlarga ma'lumotlarni kiriting.",
  "Video": "Video (onlayn) maslahat",
  "video chat": "Video(onlayn) davolash",
  "view prescription": "Retseptni ko'rish",
  "withdrawal": "A'zolikni bekor qilish",
  "withdrawal info1": "Agar siz a'zolikni bekor qilsangiz, Sizning davolanish tarixingiz",
  "withdrawal info2": "o'chiriladi va uni qayta tiklab bo'lmaydi.",
  "WithdrawalHeader": "Men aʼzolikni bekor qilaman.",
  "Yes": "Ha",
  "Your email is not verified": "Siz ro'yxatdan o'tgan elektron pochta manzilingizga xat yuborildi. \n elektron pochtangizni oching va [Hisobni faollashtirish] tugmasini bosing. \n Shundan keyin siz tizimga kirishingiz mumkin."
}
